import { render } from "./BaseCarousel.vue?vue&type=template&id=f21f2796"
import script from "./BaseCarousel.vue?vue&type=script&lang=js"
export * from "./BaseCarousel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__